import { useSnackbar } from 'notistack';
import { useMutation } from 'react-query';

import { axios } from 'lib';

const updateCompanyProfile = ({
  companyID,
  profileID,
  slug,
  website,
  aboutUs,
}) => {
  return axios.put(
    `/api/companies/${companyID}/profile/${profileID}`,
    JSON.stringify({
      slug: slug,
      website: website,
      about_us: aboutUs,
    })
  );
}
export const useUpdateCompanyProfile = (refetch) => {
  const { enqueueSnackbar } = useSnackbar();

  return useMutation({
    mutationFn: updateCompanyProfile,
    onSuccess: () => {
      enqueueSnackbar('Company profile was successfully updated', {
        variant: 'success',
      });

      refetch();
    },
    onError: (error) => {
      enqueueSnackbar(error?.message || 'Some error occured', { variant: 'error' });
    },
  });
};
